import React from 'react'
import axios from "axios";
import './content.css';
import {Progress} from 'reactstrap';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ResultContainer from "./ResultContainer";


class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            text: '',
            loaded: 0,
            isVisibleLoader: false
        }

    }

    onChangeHandler = event => {
        this.setState({
            selectedFile: event.target.files[0],
            loaded: 0
        })
    };
    onClickHandler = async () => {
        const data = new FormData()
        data.append('files', this.state.selectedFile)
        await axios.post("https://detection-service.herokuapp.com/image/upload", data, {
            onUploadProgress: ProgressEvent => {
                this.setState({
                    loaded: (ProgressEvent.loaded / ProgressEvent.total * 100),
                    isVisibleLoader: true
                })
            },
        }).then(res => {
            toast.success('upload success')
            this.setState({
                text: res.data,
                isVisibleLoader: false
            })
        }).catch(error => {
            toast.error('upload fail')
            this.setState({
                isVisibleLoader: false
            })
        })
    };

    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="mx-auto mt-4 mb-4 col-md-8">
                            <div className="form-group files">
                                <label><h5>Upload yours file here: </h5></label>
                                <input type="file" className="form-control" multiple=""
                                       onChange={this.onChangeHandler}/>
                            </div>
                            <ToastContainer/>
                            <Progress className="mx-auto mt-2 mb-2 col-md-12" max="100" color="success"
                                      value={this.state.loaded}>{Math.round(this.state.loaded, 2)}%</Progress>
                            <button type="button" className="btn btn-success btn-block"
                                    onClick={this.onClickHandler}>Upload
                            </button>
                        </div>
                    </div>
                </div>
                <ResultContainer data={this.state.text} isVisibleLoader={this.state.isVisibleLoader}/>
            </div>
        )
    };
}

export default Content;